/*
 * @Date: 2020-04-03 14:28:11
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-21 19:25:30
 * @FilePath: \st-teacher-2020\src\views\index\js\guide.ts
 */
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import utils from '@/utils/index';
// import cookies from 'js-cookie';

const userModule = namespace('user');

@Component
export default class GuideClass extends Vue {
  @userModule.Getter('getGuideOptions') guideOptions: any;

  @userModule.Mutation('updateGuideOptions') handleCloseGuide: any;

  @userModule.Action('saveOption') handleSaveOption: any;

  @userModule.Getter('isManage') isManage: any;

  @userModule.Getter('isSuperManage') isSuperManage: any;

  @userModule.Getter('isTeacher') isTeacher: any;

  // 新手引导
  private driver: any;

  private guideType?: string;

  // 初始化新手引导
  private initDriver(guideType: string) {
    let guideArr: any[] = [];
    this.guideType = guideType;
    this.driver = new Driver({
      opacity: 0.4,
      padding: 0,
      allowClose: false,
      overlayClickNext: false,
      doneBtnText: '完成',
      closeBtnText: '跳过',
      nextBtnText: '下一步',
      onNext: () => {
        const hasNext = this.driver.hasNextStep();
        if (hasNext) {
          // 继续
          utils.sendAction('index', 'history', 'id-14');
        } else {
          // 完成
          utils.sendAction('index', 'history', 'id-15');
        }
        // 判断是否是最后一步
        if (!hasNext) {
          const { myClassAndType } = this.guideOptions;
          const domNode = document.getElementById('axx-body');
          if (myClassAndType) {
            this.handleSaveOption(myClassAndType.code);
          }
          if (domNode) {
            domNode.removeEventListener('DOMNodeInserted', this.listenerDOMNodeInserted);
          }
        }
      },
      onDeselected: () => {
        const hasNext = this.driver.hasNextStep();
        const { isActivated } = this.driver;
        if (hasNext && !isActivated) {
          // 跳过&&完成
          utils.sendAction('index', 'history', 'id-16');
          // cookies.set('noclazz_guide_jump', 1);
        }
      },
    });
    if (guideType === 'myClass') {
      // 仅有班级引导
      if (!(this.isSuperManage || this.isManage || this.isTeacher)) {
        guideArr = [
          {
            element: '.history-list-item',
            popover: {
              title: '「选班选课」',
              description: '<p>选择班级，找到对应的讲次备课或者<br/>授课</p>',
              position: 'right-center',
              closeBtnText: '',
              nextBtnText: '知道了',
            },
          },
          {
            element: '#zhanwei',
            popover: {},
          },
        ];
      } else {
        guideArr = [
          {
            element: '.history-list-item',
            popover: {
              title: '「选班选课」',
              description: '<p>选择班级，找到对应的讲次备课或者<br/>授课</p>',
              position: 'right-center',
            },
          },
          {
            element: '#tab2',
            popover: {
              title: '「查看更多课程」',
              description: '如果找不到对应的班级和课程，可以点击查看更多课程哦～',
              position: 'right-center',
              closeBtnText: '',
            },
          },
        ];
      }
    } else if (guideType === 'allCourse') {
      // 仅有班型
      guideArr = [
        {
          element: '.classtype-item',
          popover: {
            title: '「选班型」',
            description: '<p>选择课程，找到对应的讲次备课</p>',
            position: 'right-center',
            closeBtnText: '',
            nextBtnText: '知道了',
          },
        },
        {
          element: '#zhanwei',
          popover: {},
        },
      ];
    }
    this.driver.reset();
    this.driver.defineSteps(guideArr);
    this.driver.start();
    const domNode = document.getElementById('axx-body');
    if (domNode) {
      domNode.addEventListener('DOMNodeInserted', this.listenerDOMNodeInserted);
    }
  }

  // 监听dom变化
  private listenerDOMNodeInserted(event: any) {
    this.driver.refresh();
  }

  // 显示新手引导
  private handleShowGuide(guideType: string) {
    const { myClassAndType } = this.guideOptions;
    const nowTime = new Date().getTime();
    // const jumpCookie = cookies.get('noclazz_guide_jump');
    if (
      (myClassAndType
      && nowTime >= myClassAndType.startTime
      && nowTime <= myClassAndType.expireTime
      && myClassAndType.isOption === 0
      )
    ) {
      this.initDriver(guideType);
    }
  }

  mounted() {
    if (this.guideOptions) {
      this.$bus.$on('showGuide', this.handleShowGuide);
    }
  }
}
